(()=>{'use strict';
 const config=document.getElementById('fd-cart-atelier-config');if(!config)return;
 const t=JSON.parse(config.textContent);let scheduled=false,addTimer=0;

 function keepCartPage(){
  const block=document.querySelector('moonbundle-cart-drawer-block');
  if(!block||block.dataset.fdPageGuard||typeof block.open!=='function')return;
  block.dataset.fdPageGuard='true';
  if(document.querySelector('[data-fd-cart-page]'))block.close();
  for(const key of ['open','openImmediate','openDrawer']){
   const original=block[key];
   if(typeof original==='function')block[key]=function(...args){
    if(document.querySelector('[data-fd-cart-page]'))return;
    return original.apply(this,args);
   };
  }
 }

 function logoNode(){
  const source=document.querySelector('#header-component .header-logo__image-container--original img,#header-component img.header-logo__image');
  if(source){
   const img=source.cloneNode(true);
   img.className='fdca-brand-logo fd-brand-logo__image';img.alt='FootDrop';
   img.removeAttribute('style');img.removeAttribute('loading');
   return img;
  }
  if(t.logo){
   const img=document.createElement('img');img.src=t.logo;img.alt='FootDrop';img.className='fdca-brand-logo fd-brand-logo__image';return img;
  }
  const fallback=document.createElement('b');fallback.className='fdca-brand-fallback';fallback.textContent='FOOTDROP';return fallback;
 }

 function makeBrand(header){
  if(!header)return;
  let brand=header.querySelector('.fdca-brand');
  if(!brand){brand=document.createElement('div');brand.className='fdca-brand';header.prepend(brand);}
  if(!brand.querySelector('.fdca-brand-mark')){
   const mark=document.createElement('span');mark.className='fdca-brand-mark';mark.append(logoNode());brand.append(mark);
  }
 }

 function paint(){
  scheduled=false;keepCartPage();
  const drawer=document.getElementById('moonbundle-cart-drawer');if(!drawer)return;
  const header=drawer.querySelector('.moonbundle-cart-drawer-header');
  const body=drawer.querySelector('.moonbundle-cart-body-scrollable');
  const title=drawer.querySelector('.moonbundle-cart-drawer-header-title');
  const titleText=t.title||'Panier';if(title&&title.textContent!==titleText)title.textContent=titleText;
  drawer.querySelector('.moonbundle-cart-drawer-close')?.setAttribute('aria-label',t.close||'Fermer le panier');
  drawer.querySelectorAll('.fdca-drawer-campaign').forEach(node=>node.remove());
  makeBrand(header);

  const empty=drawer.querySelector('.moonbundle-cart-empty');
  drawer.classList.toggle('fdca-drawer-empty',!!empty);
  if(empty){
   const text=empty.querySelector('.moonbundle-cart-empty-text');const emptyText=t.empty||'Ton vestiaire est vide';if(text&&text.textContent!==emptyText)text.textContent=emptyText;
   if(!empty.querySelector('.fdca-drawer-discover')){
    const a=document.createElement('a');a.href=t.collection_url;a.className='fdca-drawer-discover';a.textContent=(t.discover||'Découvrir les maillots')+' →';empty.append(a);
   }
  }

  if(body&&!empty&&!body.querySelector('.fd-moon-progress')){
   const progress=document.createElement('div');progress.className='fd-moon-progress';body.prepend(progress);
  }

  const footer=drawer.querySelector('.moonbundle-cart-drawer-footer');
  if(footer&&!footer.querySelector('.fdca-drawer-cart-link')){
   const link=document.createElement('a');link.className='fdca-drawer-cart-link';link.href=t.cart_url;link.textContent=(t.view_cart||'Voir le panier complet')+' ↗';footer.append(link);
  }
 }

 function animateAdd(){
  const drawer=document.getElementById('moonbundle-cart-drawer');if(!drawer)return;
  drawer.classList.remove('fdca-added');void drawer.offsetWidth;drawer.classList.add('fdca-added');
  const progress=drawer.querySelector('.fd-moon-progress');
  if(progress){progress.classList.remove('fdca-progress-pop');void progress.offsetWidth;progress.classList.add('fdca-progress-pop');}
  const first=[...drawer.querySelectorAll('.moonbundle-cart-item:not(.fd-addon-line)')][0];
  if(first){first.classList.remove('fdca-item-in');void first.offsetWidth;first.classList.add('fdca-item-in');}
  clearTimeout(addTimer);addTimer=setTimeout(()=>drawer.classList.remove('fdca-added'),650);
 }

 function openAndAnimate(){
  const block=document.querySelector('moonbundle-cart-drawer-block');
  if(block&&!document.querySelector('[data-fd-cart-page]')){
   for(const key of ['open','openImmediate','openDrawer']){
    if(typeof block[key]==='function'){try{block[key]();}catch(_){}break;}
   }
  }
  schedule();setTimeout(animateAdd,160);setTimeout(schedule,360);
 }

 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(paint);}
 const observer=new MutationObserver(records=>{
  if(records.some(r=>{
   if(r.target.closest?.('.fdca-brand,.fdca-drawer-discover,.fdca-drawer-cart-link,.fd-moon-progress'))return false;
   return r.target.closest?.('#moonbundle-cart-drawer')||[...r.addedNodes].some(n=>n.nodeType===1&&(n.id==='moonbundle-cart-drawer'||n.querySelector?.('#moonbundle-cart-drawer')));
  }))schedule();
 });
 observer.observe(document.body,{childList:true,subtree:true});
 paint();customElements.whenDefined('moonbundle-cart-drawer-block').then(schedule);
 document.addEventListener('fd:cart-added',openAndAnimate);
 document.addEventListener('cart:refresh',schedule);
 document.addEventListener('cart:updated',schedule);

 window.addEventListener('click',e=>{
  const link=e.target.closest('.fdca-drawer-cart-link,.fda-confirmation a,[data-fd-cart-link]');
  if(!link||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
  e.preventDefault();e.stopImmediatePropagation();location.assign(link.href);
 },true);
})();
